import { primaryTabManager } from 'v2/shared/utils/primary-tab-manager'
import type { BlockingModalType } from 'v2/types'
import type { CallDetails } from 'v2/types/call'
import { EventBus } from 'v2/utils/event-bus'

interface PrimaryEventsPayload {
  // General events
  LOGOUT: () => void
  LOGOUT_SUCCESS: () => void
  LOGIN_SUCCESS: () => void
  APP_FOCUSED: (isFocused: boolean) => void
  APP_ONLINE: (isOnline: boolean) => void
  APP_ACTIVE: (lastActiveTimestamp: number) => void
  APP_INACTIVE: () => void
  TRIGGER_BLOCKING_MODAL: (type: BlockingModalType) => void
  RQ_HYDRATED: () => void

  // Primary tab events
  PRIMARY_TAB_STATUS: (isPrimary: boolean) => void

  // Call related
  REDIRECT_INCOMING_CALL: (toUri: string) => void
  REJECT_INCOMING_CALL: (callUUID: string) => void
  SDK_LOGGED_IN: () => void
  CALL_TERMINATED: (isPageUnload?: boolean) => void
  CALL_FAILED: (data: { reason: string; callInfo: CallDetails }) => void

  // Events specifically created for monitoring
  // Not used anywhere else
  ON_INCOMING_CALL: (callDetails: CallDetails) => void
  CALL_TERMINATED_BROADCAST: () => void
  HANGUP_CALL: () => void

  // Flow (Agent) events
  TRIGGER_MANUAL_TEST_AGENT: () => void
}

export const PrimaryEvents = {
  // General events
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  APP_FOCUSED: 'APP_FOCUSED',
  APP_ONLINE: 'APP_ONLINE',
  APP_ACTIVE: 'APP_ACTIVE',
  APP_INACTIVE: 'APP_INACTIVE',
  TRIGGER_BLOCKING_MODAL: 'TRIGGER_BLOCKING_MODAL',
  RQ_HYDRATED: 'RQ_HYDRATED',
  // Primary tab events
  PRIMARY_TAB_STATUS: 'PRIMARY_TAB_STATUS',

  // Call related (broadcast events)
  REDIRECT_INCOMING_CALL: 'REDIRECT_INCOMING_CALL',
  REJECT_INCOMING_CALL: 'REJECT_INCOMING_CALL',
  HANGUP_CALL: 'HANGUP_CALL', // Used for monitoring, 1 case - switch call monitoring, while multi tabs are present
  // Call & Plivo SDK related (individual events)
  SDK_LOGGED_IN: 'SDK_LOGGED_IN',
  CALL_TERMINATED: 'CALL_TERMINATED',
  CALL_TERMINATED_BROADCAST: 'CALL_TERMINATED_BROADCAST', // Used for monitoring, 1 case - switch call monitoring, while multi tabs are present
  CALL_FAILED: 'CALL_FAILED',
  ON_INCOMING_CALL: 'ON_INCOMING_CALL',

  // Flow (Agent) events
  TRIGGER_MANUAL_TEST_AGENT: 'TRIGGER_MANUAL_TEST_AGENT',
} as const

export const primaryEventBus = new EventBus<PrimaryEventsPayload>(
  undefined,
  primaryTabManager.channel,
)
